/* Squad Customs Garage: sunrise/sunset sky theme + workshop time & weather chip. */
const WMO = {
  0: ['Clear', 'sun'], 1: ['Mostly clear', 'sun'], 2: ['Partly cloudy', 'cloud'], 3: ['Overcast', 'cloud'],
  45: ['Fog', 'cloud'], 48: ['Fog', 'cloud'], 51: ['Light drizzle', 'rain'], 53: ['Drizzle', 'rain'], 55: ['Drizzle', 'rain'],
  56: ['Freezing drizzle', 'rain'], 57: ['Freezing drizzle', 'rain'], 61: ['Light rain', 'rain'], 63: ['Rain', 'rain'], 65: ['Heavy rain', 'rain'],
  66: ['Freezing rain', 'rain'], 67: ['Freezing rain', 'rain'], 71: ['Light snow', 'cloud'], 73: ['Snow', 'cloud'], 75: ['Heavy snow', 'cloud'], 77: ['Snow grains', 'cloud'],
  80: ['Showers', 'rain'], 81: ['Showers', 'rain'], 82: ['Heavy showers', 'rain'], 85: ['Snow showers', 'cloud'], 86: ['Snow showers', 'cloud'],
  95: ['Thunderstorm', 'storm'], 96: ['Thunderstorm', 'storm'], 99: ['Thunderstorm', 'storm'],
};
const PHASES = ['dawn', 'day', 'dusk', 'night'];
const DAY_SETS = { 'mon-fri': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'], 'mon-sat': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], 'every-day': ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] };

function sunTimes(date, lat, lng) {
  const rad = Math.PI / 180, J1970 = 2440588, J2000 = 2451545;
  const toJulian = d => d.valueOf() / 864e5 - 0.5 + J1970;
  const fromJulian = j => new Date((j + 0.5 - J1970) * 864e5);
  const d = toJulian(date) - J2000, lw = -lng * rad, phi = lat * rad;
  const n = Math.round(d - 0.0009 - lw / (2 * Math.PI));
  const ds = 0.0009 + lw / (2 * Math.PI) + n;
  const M = rad * (357.5291 + 0.98560028 * ds);
  const C = rad * (1.9148 * Math.sin(M) + 0.02 * Math.sin(2 * M) + 0.0003 * Math.sin(3 * M));
  const L = M + C + rad * 102.9372 + Math.PI;
  const Jnoon = J2000 + ds + 0.0053 * Math.sin(M) - 0.0069 * Math.sin(2 * L);
  const dec = Math.asin(Math.sin(L) * Math.sin(rad * 23.4397));
  const w = Math.acos((Math.sin(-0.833 * rad) - Math.sin(phi) * Math.sin(dec)) / (Math.cos(phi) * Math.cos(dec)));
  const Jset = J2000 + 0.0009 + (w + lw) / (2 * Math.PI) + n + 0.0053 * Math.sin(M) - 0.0069 * Math.sin(2 * L);
  return { rise: fromJulian(Jnoon - (Jset - Jnoon)), set: fromJulian(Jset) };
}

function partsIn(tz, date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-AU', { hour: 'numeric', minute: 'numeric', hour12: false, weekday: 'short', timeZone: tz }).formatToParts(date);
  const o = {}; parts.forEach(p => { o[p.type] = p.value; });
  return { minutes: (Number(o.hour) % 24) * 60 + Number(o.minute), weekday: o.weekday };
}
const hm = s => { const [h, m] = String(s).split(':').map(Number); return h * 60 + (m || 0); };
const clockLabel = (minutes) => { const h = Math.floor(minutes / 60) % 24, m = minutes % 60, ap = h >= 12 ? 'PM' : 'AM'; return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${ap}`; };

class SquadSky extends HTMLElement {
  connectedCallback() {
    if (this.dataset.mounted) return;
    this.dataset.mounted = '1';
    this.workshop = { tz: this.dataset.tz || 'Australia/Sydney', lat: Number(this.dataset.lat) || -33.8688, lng: Number(this.dataset.lng) || 151.2093, label: this.dataset.label || 'Sydney' };
    this.source = this.dataset.source || 'visitor';
    this.setLocation(this.workshop, 'workshop');
    this.mode = this.dataset.mode || 'auto';
    this.openMin = hm(this.dataset.open || '08:30');
    this.closeMin = hm(this.dataset.close || '17:00');
    this.days = DAY_SETS[this.dataset.days] || DAY_SETS['mon-fri'];
    this.override = sessionStorage.getItem('scg-sky-override') || '';
    this.modePref = localStorage.getItem('scg-theme') || 'auto';
    this.mount();
    this.computeFallbackSun();
    this.render();
    this.hidden = false;
    this.resolveLocation().then(() => this.loadWeather()).then(() => this.render());
    this.timer = setInterval(() => this.render(), 30000);
    this.addEventListener('click', e => this.onClick(e));
    document.addEventListener('click', e => { if (!this.contains(e.target)) this.togglePanel(false); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.togglePanel(false); });
  }
  mount() {
    const bar = document.querySelector('#header-group aside.announcement-bar');
    if (bar && !bar.contains(this)) { bar.classList.add('scg-has-sky'); bar.appendChild(this); }
    else if (!bar) this.classList.add('scg-sky--standalone');
  }
  setLocation(loc, kind) {
    this.tz = loc.tz; this.lat = loc.lat; this.lng = loc.lng; this.label = loc.label; this.locKind = kind;
    this.computeFallbackSun();
  }
  async resolveLocation() {
    if (this.source !== 'visitor') return;
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const precise = JSON.parse(localStorage.getItem('scg-sky-precise') || 'null');
      if (precise && Date.now() - precise.t < 7 * 864e5) { this.setLocation({ ...precise, tz: browserTz || precise.tz }, 'precise'); return; }
      const cached = JSON.parse(sessionStorage.getItem('scg-sky-loc') || 'null');
      if (cached) { this.setLocation(cached, 'ip'); return; }
      const res = await fetch('https://get.geojs.io/v1/ip/geo.json');
      if (!res.ok) throw new Error(res.status);
      const g = await res.json();
      const loc = { lat: Number(g.latitude), lng: Number(g.longitude), tz: browserTz || g.timezone || this.workshop.tz, label: g.city || g.region || g.country || 'your area' };
      if (!Number.isFinite(loc.lat) || !Number.isFinite(loc.lng)) throw new Error('no coords');
      sessionStorage.setItem('scg-sky-loc', JSON.stringify(loc));
      this.setLocation(loc, 'ip');
    } catch (err) {
      if (browserTz) this.setLocation({ ...this.workshop, tz: browserTz, label: 'your area' }, 'tz');
    }
  }
  locatePrecise() {
    if (!navigator.geolocation) return;
    const foot = this.querySelector('[data-scg-sky-foot]');
    navigator.geolocation.getCurrentPosition(async pos => {
      const loc = { lat: Number(pos.coords.latitude.toFixed(3)), lng: Number(pos.coords.longitude.toFixed(3)), tz: Intl.DateTimeFormat().resolvedOptions().timeZone || this.tz, label: 'your location', t: Date.now() };
      localStorage.setItem('scg-sky-precise', JSON.stringify(loc));
      this.setLocation(loc, 'precise');
      this.weather = null; sessionStorage.removeItem('scg-sky-wx');
      await this.loadWeather(); this.render();
    }, () => { if (foot) foot.insertAdjacentText('beforeend', ' Location permission was not granted.'); }, { maximumAge: 6e5, timeout: 8000 });
  }
  computeFallbackSun() {
    const t = sunTimes(new Date(), this.lat, this.lng);
    this.sun = { rise: partsIn(this.tz, t.rise).minutes, set: partsIn(this.tz, t.set).minutes, source: 'calc' };
  }
  async loadWeather() {
    try {
      const cached = JSON.parse(sessionStorage.getItem('scg-sky-wx') || 'null');
      if (cached && Date.now() - cached.t < 15 * 60 * 1000 && cached.key === `${this.lat},${this.lng}`) { this.applyWeather(cached.data); return; }
      const url = `https://api.open-meteo.com/v1/forecast?latitude=${this.lat}&longitude=${this.lng}&current=temperature_2m,weather_code,is_day&daily=sunrise,sunset&forecast_days=1&timezone=${encodeURIComponent(this.tz)}`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      sessionStorage.setItem('scg-sky-wx', JSON.stringify({ t: Date.now(), key: `${this.lat},${this.lng}`, data }));
      this.applyWeather(data);
    } catch (err) { this.weather = null; }
  }
  applyWeather(data) {
    this.weather = { temp: Math.round(data.current.temperature_2m), code: data.current.weather_code, isDay: data.current.is_day === 1 };
    if (data.daily?.sunrise?.[0]) {
      const m = s => { const [h, mm] = s.split('T')[1].split(':').map(Number); return h * 60 + mm; };
      this.sun = { rise: m(data.daily.sunrise[0]), set: m(data.daily.sunset[0]), source: 'api' };
    }
  }
  phaseFor(minutes) {
    const { rise, set } = this.sun;
    if (minutes >= rise - 45 && minutes <= rise + 40) return 'dawn';
    if (minutes >= set - 45 && minutes <= set + 40) return 'dusk';
    if (minutes > rise + 40 && minutes < set - 45) return 'day';
    return 'night';
  }
  render() {
    const now = partsIn(this.tz);
    const live = this.phaseFor(now.minutes);
    const phase = this.override || (this.mode === 'night' ? 'night' : live);
    const theme = this.themeFor(phase);
    const root = document.documentElement;
    const changed = (root.dataset.scgSky && root.dataset.scgSky !== phase) || (root.dataset.scgTheme && root.dataset.scgTheme !== theme);
    if (changed) this.crossfade(() => { root.dataset.scgSky = phase; this.applyAppearance(phase); });
    else { root.dataset.scgSky = phase; this.applyAppearance(phase); }
    const w = this.weather ? (WMO[this.weather.code] || ['Cloudy', 'cloud']) : null;
    let kind = w ? w[1] : (phase === 'night' ? 'moon' : 'sun');
    if (kind === 'sun' && phase === 'night') kind = 'moon';
    if (kind === 'cloud' && phase === 'night' && this.weather?.code <= 1) kind = 'moon';
    this.querySelector('[data-scg-sky-icon]').dataset.kind = kind;
    const time = clockLabel(now.minutes);
    this.querySelector('[data-scg-sky-time]').textContent = time;
    this.querySelector('[data-scg-sky-temp]').textContent = w ? `${this.weather.temp}°` : '';
    this.querySelector('[data-scg-sky-cond]').textContent = w ? w[0] : '';
    this.querySelector('[data-scg-sky-time-long]').textContent = time;
    this.querySelector('[data-scg-sky-weather]').textContent = w ? `${this.weather.temp}°C · ${w[0]}` : 'Weather unavailable';
    const lbl = this.querySelector('[data-scg-sky-label]'); if (lbl) lbl.textContent = this.label || '';
    const kick = this.querySelector('[data-scg-sky-kicker]'); if (kick) kick.textContent = this.locKind === 'workshop' ? 'Workshop sky' : 'Your sky';
    const shopNow = partsIn(this.workshop.tz);
    const wt = this.querySelector('[data-scg-sky-workshop-time]'); if (wt) wt.textContent = clockLabel(shopNow.minutes);
    const open = this.days.includes(shopNow.weekday) && shopNow.minutes >= this.openMin && shopNow.minutes < this.closeMin;
    const status = this.querySelector('[data-scg-sky-status]');
    status.textContent = open ? 'Open now' : `Closed · opens ${clockLabel(this.openMin).toLowerCase()}`;
    status.dataset.open = open ? 'true' : 'false';
    this.querySelector('[data-scg-sky-sunrise]').textContent = clockLabel(this.sun.rise);
    this.querySelector('[data-scg-sky-sunset]').textContent = clockLabel(this.sun.set);
    const pct = Math.max(0, Math.min(100, ((now.minutes - this.sun.rise) / (this.sun.set - this.sun.rise)) * 100));
    this.querySelector('[data-scg-sky-sun]').style.setProperty('--sun', `${pct}%`);
    const cycle = this.querySelector('[data-scg-sky-cycle]');
    if (cycle) cycle.textContent = this.override ? `Previewing ${this.override} · back to live` : 'Preview day / night';
  }
  themeFor(phase) {
    return this.modePref === 'auto' ? ((phase === 'dawn' || phase === 'day') ? 'light' : 'dark') : this.modePref;
  }
  /* Smooth colour change: snapshot the current sky gradients as fading overlays, then let every colour transition. */
  crossfade(apply) {
    const root = document.documentElement;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { apply(); return; }
    const layers = [];
    const snap = (el, pseudo) => {
      if (!el) return;
      const cs = getComputedStyle(el, pseudo || null);
      if (!cs.backgroundImage || cs.backgroundImage === 'none') return;
      const span = document.createElement('span');
      span.className = 'scg-fade-layer';
      span.style.cssText = `background:${cs.backgroundImage};opacity:${cs.opacity};${pseudo ? 'height:' + cs.height + ';' : ''}`;
      el.appendChild(span); layers.push(span);
    };
    snap(document.querySelector('#header-group .announcement-bar'));
    document.querySelectorAll('.squad-home .sg-hero, .scg-page').forEach(el => snap(el, '::before'));
    root.classList.add('scg-fading');
    void root.offsetWidth;
    apply();
    requestAnimationFrame(() => { layers.forEach(l => { l.style.opacity = '0'; }); });
    clearTimeout(this._fadeTimer);
    this._fadeTimer = setTimeout(() => { layers.forEach(l => l.remove()); root.classList.remove('scg-fading'); }, 1500);
  }
  applyAppearance(phase) {
    const theme = this.themeFor(phase);
    document.documentElement.dataset.scgTheme = theme;
    try { localStorage.setItem('scg-theme-last', theme); } catch (err) {}
    const btn = this.querySelector('[data-scg-mode-cycle]');
    if (btn) { btn.dataset.mode = this.modePref; const label = `Appearance: ${this.modePref}${this.modePref === 'auto' ? ` (${theme} now)` : ''}`; btn.title = label; btn.setAttribute('aria-label', `${label}. Click to switch between auto, light and dark.`); }
    this.querySelectorAll('[data-scg-mode]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.scgMode === this.modePref)));
  }
  setMode(mode) {
    this.modePref = mode;
    try { if (mode === 'auto') localStorage.removeItem('scg-theme'); else localStorage.setItem('scg-theme', mode); } catch (err) {}
    this.render();
  }
  onClick(e) {
    const seg = e.target.closest('[data-scg-mode]'); if (seg) { this.setMode(seg.dataset.scgMode); return; }
    if (e.target.closest('[data-scg-mode-cycle]')) { const order = ['auto', 'light', 'dark']; this.setMode(order[(order.indexOf(this.modePref) + 1) % 3]); return; }
    if (e.target.closest('[data-scg-sky-toggle]')) { this.togglePanel(); return; }
    if (e.target.closest('[data-scg-sky-locate]')) { this.locatePrecise(); return; }
    if (e.target.closest('[data-scg-sky-cycle]')) {
      const i = PHASES.indexOf(this.override);
      this.override = this.override && i === PHASES.length - 1 ? '' : PHASES[i + 1];
      if (this.override) sessionStorage.setItem('scg-sky-override', this.override); else sessionStorage.removeItem('scg-sky-override');
      this.render();
    }
  }
  togglePanel(force) {
    const panel = this.querySelector('.scg-sky-panel'), btn = this.querySelector('[data-scg-sky-toggle]');
    const open = typeof force === 'boolean' ? force : panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
  }
}
if (!customElements.get('squad-sky')) customElements.define('squad-sky', SquadSky);
